!function () {
  "use strict";

  if (customElements.get("rewards-club-status")) return;

  var GIFT_ICON =
    '<svg aria-hidden="true" focusable="false" class="icon" viewBox="0 0 24 24"><path d="M20 12v9.4a.6.6 0 0 1-.6.6H4.6a.6.6 0 0 1-.6-.6V12M21.4 7H2.6a.6.6 0 0 0-.6.6v3.8a.6.6 0 0 0 .6.6h18.8a.6.6 0 0 0 .6-.6V7.6a.6.6 0 0 0-.6-.6zM12 22V7M12 7H7.5a2.5 2.5 0 1 1 0-5C11 2 12 7 12 7Zm0 0h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7Z" stroke="currentColor" stroke-width="1.6" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  var MONTHS = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];

  function escapeHtml(value) {
    var div = document.createElement("div");
    div.textContent = value == null ? "" : String(value);
    return div.innerHTML;
  }

  function formatDate(isoDate) {
    if (!isoDate) return "";
    var parts = isoDate.split("-");
    if (parts.length !== 3) return isoDate;
    var month = MONTHS[parseInt(parts[1], 10) - 1] || parts[1];
    return parseInt(parts[2], 10) + " " + month;
  }

  customElements.define(
    "rewards-club-status",
    class extends HTMLElement {
      connectedCallback() {
        var loggedIn = this.dataset.loggedIn === "true";
        if (!loggedIn) {
          this.renderLoggedOut();
          return;
        }
        this.renderLoading();
        this.fetchStatus();
      }

      fetchStatus() {
        var url = this.dataset.statusWebhookUrl;
        var email = this.dataset.customerEmail;
        if (!url || !email) {
          this.renderLoggedOut();
          return;
        }

        var self = this;
        fetch(url, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email: email })
        })
          .then(function (r) {
            return r.json();
          })
          .then(function (data) {
            document.dispatchEvent(new CustomEvent("rewards-club:status", { detail: data }));
            if (data && data.found) {
              self.renderStatus(data);
            } else {
              self.renderUnknown();
            }
          })
          .catch(function () {
            self.renderUnknown();
          });
      }

      renderLoading() {
        this.innerHTML =
          '<div class="rewards-club__status rewards-club__status--loading">' +
          '<span class="rewards-club__status-spinner" aria-hidden="true"></span>' +
          "<span>Cargando tu estado del club…</span>" +
          "</div>";
      }

      renderLoggedOut() {
        var loginUrl = this.dataset.loginUrl || "/account/login";
        this.innerHTML =
          '<div class="rewards-club__status rewards-club__status--guest">' +
          "<p>Inicia sesión para ver tu nivel, tus puntos y tu cupón de cumpleaños.</p>" +
          '<a href="' +
          escapeHtml(loginUrl) +
          '" class="rewards-club__ghost-link">Iniciar sesión</a>' +
          "</div>";
      }

      renderUnknown() {
        this.innerHTML =
          '<div class="rewards-club__status rewards-club__status--guest">' +
          "<p>Aún no encontramos tu cuenta del club. Actualiza tus datos abajo para activarla.</p>" +
          "</div>";
      }

      renderStatus(data) {
        var name = this.dataset.customerName || "";
        var tierLabel = data.tier_label || "Origen";
        var points = data.points || 0;
        var coupon = data.birthday_coupon;

        var html =
          '<div class="rewards-club__status rewards-club__status--active">' +
          '<div class="rewards-club__status-main">' +
          '<span class="rewards-club__status-greeting">' +
          (name ? "Hola, " + escapeHtml(name) : "Hola") +
          "</span>" +
          '<div class="rewards-club__status-tier-row">' +
          '<span class="rewards-club__status-tier">Nivel ' +
          escapeHtml(tierLabel) +
          "</span>" +
          '<span class="rewards-club__status-badge">Activo</span>' +
          "</div>" +
          '<span class="rewards-club__status-points">' +
          points +
          " puntos acumulados este año</span>" +
          "</div>";

        if (coupon) {
          html +=
            '<div class="rewards-club__status-coupon">' +
            '<div class="rewards-club__status-coupon-icon">' +
            GIFT_ICON +
            "</div>" +
            '<div class="rewards-club__status-coupon-text">' +
            "<strong>" +
            escapeHtml(coupon.discount_label || "Cupón de cumpleaños") +
            "</strong>" +
            "<span>Código <code>" +
            escapeHtml(coupon.code) +
            "</code> · vence " +
            escapeHtml(formatDate(coupon.expires)) +
            "</span>" +
            "</div>" +
            "</div>";
        }

        html += "</div>";
        this.innerHTML = html;
      }
    }
  );
}();
